import { render, staticRenderFns } from "./StandardButton.vue?vue&type=template&id=60f03ca8&scoped=true&"
import script from "./StandardButton.vue?vue&type=script&lang=js&"
export * from "./StandardButton.vue?vue&type=script&lang=js&"
import style0 from "./StandardButton.vue?vue&type=style&index=0&id=60f03ca8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f03ca8",
  null
  
)

export default component.exports